export const apiURL = process.env.REACT_APP_API_URL;
export const pyApiURL = process.env.REACT_APP_PYTHON_APi_URL;
export const isPolyREST = process.env.REACT_APP_REST_DATA === "POLY";
export const isInternalWS = process.env.REACT_APP_WS_DATA === "INTERNAL";
export const wsUrl = "https://ws.tradealgo.com/cometd";
// process.env.REACT_APP_WS_URL

/**
 * TRAD-1295 — Wealth Series performance is restated onto the 10:00 AM ET rebalance
 * basis. The recalculated series is served by the same endpoints, same auth, same
 * response shape, behind this opt-in query param, so the flip is frontend-only.
 *
 * Wealth Series (Pro) only — Lite endpoints and Bitcoin Navigator deliberately do
 * not take the param, so their call sites are left alone.
 */
export const wsDataset = "v2";

export const withWsDataset = (url, enabled = true) =>
  enabled ? `${url}${url.includes("?") ? "&" : "?"}dataset=${wsDataset}` : url;
